<template>
  <div class="detail_background" v-loading="loading">
    <div class="table_header">
      <div class="table_header_title">
        {{ $t("Relationship.CompanySnapshot") }}
      </div>
      <div class="table_header_menus">
        <div class="display_switch">
          <div
            @click="changeSwitch(false)"
            :class="{ active: !isShowBackground }"
          >
            <i class="iconfont icon-xiangqing" />
          </div>
          <div
            @click="changeSwitch(true)"
            :class="{ active: isShowBackground }"
          >
            <i class="iconfont icon-shujulaiyuan" />
          </div>
        </div>
      </div>
    </div>
    <div class="background_eacharts_box" v-if="isShowBackground">
      <RelationshipEchart
        :companyName="detailInfo?.base?.companyName"
      ></RelationshipEchart>
    </div>
    <template v-else>
      <div class="tab_con_desc_item">
        <div class="tab_con_desc_item_con">
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.CompanyName") }}
            </div>
            <div
              class="tab_con_desc_item_con_list_con link_text"
              @click="linkToCompany(detailInfo)"
            >
              {{ detailInfo?.base?.companyName || "-" }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.RegName") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ detailInfo?.base?.companyNameNative || "-" }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.Address") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ detailInfo?.base?.address || "-" }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.Website") }}
            </div>
            <div
              class="tab_con_desc_item_con_list_con"
              :class="detailInfo?.base?.website ? 'link_text' : ''"
              @click="linkToWebsite(detailInfo?.base?.website)"
            >
              {{ detailInfo?.base?.website || "-" }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.CountyCity") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{
                detailInfo?.base?.durant != "-" ? detailInfo?.base?.durant : ""
              }}
              {{
                detailInfo?.base?.durant != "-" && detailInfo?.base?.city != "-"
                  ? "  "
                  : ""
              }}
              {{ detailInfo?.base?.city != "-" ? detailInfo?.base?.city : "" }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.Email") }}
            </div>
            <div
              class="tab_con_desc_item_con_list_con link_text"
              @click="linkToEmail(detailInfo?.base?.email)"
            >
              {{ detailInfo?.base?.email || "-" }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.ProvinceState") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ detailInfo?.base?.province || "-" }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.Phone") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ detailInfo?.base?.tel || "-" }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.CountryRegion") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              <img :src="detailInfo?.base?.img" />
              {{ detailInfo?.base?.country }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.LastUpdate") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ detailInfo?.base?.lastUpdate || "-" }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.ZipCode") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ detailInfo?.base?.postCode || "-" }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.DataSource") }}
            </div>
            <div class="tab_con_desc_item_con_list_con link_text">
              <span
                v-for="(item, index) in detailInfo?.base?.dataSource"
                :key="index"
                @click="linkToSource(item.website)"
              >
                {{ item.register }}</span
              >
              <!-- {{ detailSource }} -->
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isShowBackground" class="tab_con_desc_item">
        <div class="tab_con_desc_item_title">
          <span>{{ $t("Relationship.CompanyProfile") }}</span>
        </div>
        <div class="tab_con_desc_item_con">
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.CompanyName") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ obj?.companyName }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.Jurisdiction") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ obj?.jurisdiction }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.CoNativeName") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ obj?.companyNameNative }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.RegisteredAddress") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ obj?.addressNative }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.CompanyID") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ obj?.companyID }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.ProvinceState") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ obj?.province }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.VATNumber") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ obj?.vATNumber }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.CountryRegion") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">{{ obj?.country }}</div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.StockExchangeNumber") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ obj?.stockCode }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.ZipCode") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ obj?.postCode }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.Listed") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">{{ obj?.listed }}</div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.OperatingAddress") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ obj?.operatingAddress }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.RegistrationDate") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ obj?.registrationDate }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.LegalForm") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ obj?.legalForm }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.CountryRegion") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">{{ obj?.country }}</div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.CompanyType") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ obj?.companyType }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.ZipCode") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ obj?.postCode }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.LegalStatus") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ obj?.legalStatus }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.LastUpdate") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ obj?.updateTime }}
            </div>
          </div>
          <div class="tab_con_desc_item_con_list">
            <div class="tab_con_desc_item_con_list_label">
              {{ $t("Relationship.DataSource") }}
            </div>
            <div class="tab_con_desc_item_con_list_con">
              {{ profileSource }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mixins1 } from "@/mixins/index";
import RelationshipEchart from "./Com_Tree-echart.vue";
import { getCompanyProfile } from "@/api/companyApi";

export default {
  name: "UboDetail1",
  props: {
    detailInfo: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      isShowBackground: false,
      obj: {},
      loading: false,
    };
  },
  mixins: [mixins1],
  computed: {
    detailSource() {
      let source = "";
      let list = [];
      list = this.detailInfo?.base?.dataSource || [];
      (list ?? []).forEach((element) => {
        source += element.register;
      });
      return source;
    },
    profileSource() {
      let source = "";
      let list = [];
      list = this.obj?.dataSource || [];
      (list ?? []).forEach((element) => {
        source += element.register;
      });
      return source;
    },
  },
  components: { RelationshipEchart },
  mounted() {
    this.getCompanyProfilelist();
  },
  methods: {
    changeSwitch(val) {
      this.isShowBackground = val;
    },
    getCompanyProfilelist() {
      const id3a = this.$route.query.id3a;
      this.loading = true;
      getCompanyProfile({
        id3a: id3a,
      })
        .then((res) => {
          if (res.code == 200) {
            this.obj = res.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    linkToCompany(item) {
      if (item?.base?.companyName && item?.base?.companyName !== "-") {
        let routeData = this.$router.resolve({
          path:
            "/index/company/details/" +
            item.base.aaaId +
            "/background/snapshot?id3a=" +
            item.base.aaaId +
            "&companyCountry=" +
            item.base.countryFlag +
            "&companyCountryEn=" +
            item.base.countryEn +
            "&keword=2",
        });

        window.open(routeData.href, "_blank");
      }
    },
    linkToWebsite(website) {
      if (website && website !== "-") {
        window.open(`http://${website}`, "_blank");
      }
    },
    linkToEmail(email) {
      if (email && email !== "-") {
        window.open(`mailto:${email}`, "_blank");
      }
    },
    linkToSource(source) {
      if (source && source !== "-") {
        if (source.includes("http")) {
          let routeData = source;
          window.open(routeData, "_blank");
        } else {
          let routeData = "http://" + source;
          window.open(routeData, "_blank");
        }
      }
    },
  },
};
</script>
<style scoped>
.link_text {
  color: #b44818;
  cursor: pointer;
  line-height: 20px;
}
.background_eacharts_box {
  margin-top: 30px;
  width: 100%;
  height: 1184px;
  background: #f5f5f5;
}
.tab_con_desc_item_title {
  height: 40px;
  line-height: 40px;
  margin-bottom: 25px;
}

.table_header_title,
.tab_con_desc_item_title span {
  color: rgb(96, 60, 44);
}

@media (max-width: 1920px) {
  .tab_con_desc_item_title {
    margin-bottom: 15px;
  }
}
</style>
